module.exports = __webpack_public_path__ + "img/C000040.82f13a3f.png";